var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1983","data-name":"Group 1983","transform":"translate(1.414 1.414)"},[React.createElement("path",{"id":"Path_1939","data-name":"Path 1939","d":"M0,0V11.926","transform":"translate(8.433 16.82) rotate(135)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_1940","data-name":"Path 1940","d":"M0,11.925V0","transform":"translate(8.432 0) rotate(45)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

LeftArrow.defaultProps = {"width":"11.261","height":"19.649","viewBox":"0 0 11.261 19.649"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
